export const policiesForInstituteOnline = [
  {
    value: "vi-policies-for-middlebury-institute-online",
    label: "VI. Policies for Middlebury Institute Online",
    className: "vi-policies-for-middlebury-institute-online",
    children: [
      {
        value: "vi-policies-for-middlebury-institute-online/a-general-policies",
        label: "A. General Principles",
        className: "a-general-policies",
        children: [
          {
            value: "vi-policies-for-middlebury-institute-online/a-general-policies/a-1-mission-guiding-principles",
            label: "A.1. Mission & Guiding Principles",
            className: "a-1-mission-guiding-principles"
          },
          {
            value: "vi-policies-for-middlebury-institute-online/a-general-policies/a-2-scope",
            label: "A.2. Scope",
            className: "a-2-scope",
          }
        ]
      },
      {
        value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies",
        label: "B. Academic Policies",
        className: "vi-b-academic-policies",
        children: [
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-1-academic-integrity",
            label: "B.1. Academic Integrity",
            className: "b-1-academic-integrity",
            children: [ 
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-1-academic-integrity/b-1-a-definitions",
                label: "B.1.a. Definitions",
                className: "b-1-a-definitions",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-1-academic-integrity/b-1-b-student-responsibilities",
                label: "B.1.b. Student Responsibilities for their Academic Work",
                className: "b-1-b-student-responsibilities",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-1-academic-integrity/b-1-c-violations-of-academic-honesty-policy",
                label: "B.1.c. Violations of the Academic Honesty Policy, Procedures, and Disciplinary Actions",
                className: "b-1-c-violations-of-academic-honesty-policy",
              }
            ]
          },
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-2-academic-calendar",
            label: "B.2. Academic Calendar",
            className: "b-2-academic-calendar",
          },
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment",
            label: "B.3. Policies Concerning Enrollment and Payment",
            className: "b-3-policies-concerning-enrollment-payment",
            children: [
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-a-full-time-part-time",
                label: "B.3.a. Full-Time and Part-Time Enrollment Status",
                className: "b-3-a-full-time-part-time"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-b-payment-of-fees",
                label: "B.3.b. Payment of Fees",
                className: "b-3-b-payment-of-fees"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-c-tuition-refunds",
                label: "B.3.c. Tuition Refunds",
                className: "b-3-c-tuition-refunds"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-d-adding-dropping-courses",
                label: "B.3.d. Adding or Dropping Courses",
                className: "b-3-d-adding-dropping-courses"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-e-change-of-degree-program",
                label: "B.3.e. Change of Degree Program",
                className: "b-3-e-change-of-degree-program"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-f-international-students-online-courses",
                label: "B.3.f. International Students Enrolling in Online Courses",
                className: "b-3-f-international-students-online-courses"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-g-auditing-courses",
                label: "B.3.g. Auditing Courses",
                className: "b-3-g-auditing-courses"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-h-repeating-courses",
                label: "B.3.h. Repeating Courses",
                className: "b-3-h-repeating-courses"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-i-registration-policies",
                label: "B.3.i. Registration Policies for Non-Degree Students",
                className: "b-3-i-registration-policies"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-j-english-language-proficiency",
                label: "B.3.j. English Language Proficiency",
                className: "b-3-j-english-language-proficiency"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-k-course-cancellation-for-low-enrollment",
                label: "B.3.k. Course Cancellation for Low Enrollment",
                className: "b-3-k-course-cancellation-for-low-enrollment"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-3-policies-concerning-enrollment-payment/b-3-l-administrative-withdrawal-due-to-non-participation",
                label: "B.3.l. Administrative Withdrawal Due to Non-Participation",
                className: "b-3-l-administrative-withdrawal-due-to-non-participation"
              }
            ]
          },
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-4-students-academic-responsibilities",
            label: "B.4. Students' Academic Responsibilities",
            className: "b-4-students-academic-responsibilities",
          },
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies",
            label: "B.5. Grades, Credits, and Academic Policies",
            className: "b-5-grades-credits-academic-policies",
            children: [
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-a-grading-system",
                label: "B.5.a. Grading system",
                className: "b-5-a-grading-system",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-b-disputed-academic-evaluation-procedures",
                label: "B.5.b. Disputed Academic Evaluation Procedures",
                className: "b-5-b-disputed-academic-evaluation-procedures",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-c-incomplete-grades",
                label: "B.5.c. Incomplete Grades",
                className: "b-5-c-incomplete-grades",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-d-assignment-of-in-progress",
                label: "B.5.d. Assignment of \"In Progress\"",
                className: "b-5-d-assignment-of-in-progress",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-e-academic-standing",
                label: "B.5.e. Academic Standing",
                className: "b-5-e-academic-standing",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-f-academic-probation",
                label: "B.5.f. Academic Probation",
                className: "b-5-f-academic-probation",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-g-time-limit-for-completion",
                label: "B.5.g. Time Limit for Completion of Degree",
                className: "b-5-g-time-limit-for-completion",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-h-petition-for-waiver",
                label: "B.5.h. Petition for Waiver of Academic Requirements",
                className: "b-5-h-petition-for-waiver",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-i-transfer-of-credit",
                label: "B.5.i. Transfer of Credit From Other Institutions",
                className: "b-5-i-transfer-of-credit",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-5-grades-credits-academic-policies/b-5-j-graduation-with-honors",
                label: "B.5.j. Graduation with Honors",
                className: "b-5-j-graduation-with-honors",
              },
            ]
          },
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability",
            label: "B.6. Unavailability, Leaves of Absence, Withdrawal, Suspension, Expulsion, and Graduation",
            className: "b-6-unavailability",
            children: [
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-a-student-unavailability",
                label: "B.6.a. Student Unavailability",
                className: "b-6-a-student-unavailability",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-b-instructor-unavailability",
                label: "B.6.b. Instructor Unavailability",
                className: "b-6-b-instructor-unavailability",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-c-leave-of-absence",
                label: "B.6.c. Leave of Absence - Student Initiated",
                className: "b-6-c-leave-of-absence",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-d-graduation",
                label: "B.6.d. Graduation",
                className: "b-6-d-graduation",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-e-withdrawal-from-institute-online",
                label: "B.6.e. Withdrawal from the Middlebury Institute Online",
                className: "b-6-e-withdrawal-from-institute-online",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-f-readmission-to-institute-online",
                label: "B.6.f. Readmission to the Middlebury Institute Online",
                className: "b-6-f-readmission-to-institute-online",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-g-return-of-title-iv",
                label: "B.6.g. Return of Title IV (Federal) Funds",
                className: "b-6-g-return-of-title-iv",
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-6-unavailability/b-6-h-academic-records",
                label: "B.6.h. Academic Records",
                className: "b-6-h-academic-records",
              }
            ]
          },
          {
            value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-7-grievances",
            label: "B.7. Grievances",
            className: "b-7-grievances",
            children: [
              {
                value: "vi-policies-for-middlebury-institute-online/vi-b-academic-policies/b-7-grievances/b-7-a-student-complaint-process",
                label: "B.7.a. Student Complaint Process",
                className: "b-7-a-student-complaint-process",
              }
            ]
          }
        ]
      },
      {
        value: "vi-policies-for-middlebury-institute-online/vi-c-student-life-policies",
        label: "C. Student Life Policies",
        className: "vi-c-student-life-policies",
        children: [
          {
            value: "vi-policies-for-middlebury-institute-online/vi-c-student-life-policies/c-1-conduct",
            label: "C.1. Conduct",
            className: "c-1-conduct",
            children: [
              {
                value: "vi-policies-for-middlebury-institute-online/vi-c-student-life-policies/c-1-conduct/c-1-a-general-conduct-policy",
                label: "C.1.a. General Conduct Policy",
                className: "c-1-a-general-conduct-policy"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-c-student-life-policies/c-1-conduct/c-1-b-student-conduct-policy-overview",
                label: "C.1.b. Student Conduct Policy Overview",
                className: "c-1-b-student-conduct-policy-overview"
              },
              {
                value: "vi-policies-for-middlebury-institute-online/vi-c-student-life-policies/c-1-conduct/c-1-c-student-conduct-disciplinary-process",
                label: "C.1.c. Student Conduct Disciplinary Process",
                className: "c-1-c-student-conduct-disciplinary-process"
              }
            ]
          }
        ]
      },
      {
        value: "vi-policies-for-middlebury-institute-online/vi-policy-history",
        label: "Policy History",
        className: "vi-policy-history",
      }
    ]
  }
]